import {
  matchQuery,
  MutationCache,
  QueryCache,
  QueryClient,
  type QueryKey,
} from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      networkMode: 'always',
      retry: import.meta.env.DEV ? false : void 0,
    },
    mutations: {
      networkMode: 'always',
    },
  },
  queryCache: new QueryCache({
    onError(error) {
      Promise.reject(error);
    },
  }),
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      const { mutationKey, meta } = mutation.options;

      if (mutationKey) {
        queryClient.invalidateQueries({
          queryKey: mutationKey,
        });
      }

      if (meta?.invalidates?.length) {
        queryClient.invalidateQueries({
          predicate: (query) => {
            return (
              meta.invalidates?.some(({ queryKey }) =>
                matchQuery({ queryKey }, query),
              ) ?? false
            );
          },
        });
      }
    },
  }),
});

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      /**
       * 指定操作成功后需要自动失效的缓存
       *
       * 通常，
       */
      invalidates?: Array<{ queryKey: QueryKey }>;
    };
  }
}
